import { cn } from "@/lib/utils"

type BetterDocTableProps = React.TableHTMLAttributes<HTMLTableElement> & { "data-testid": string }

type BetterDocTableHeaderCellProps = React.ThHTMLAttributes<HTMLTableCellElement>

type BetterDocTableCellProps = React.TdHTMLAttributes<HTMLTableCellElement>

export const BetterDocTable = ({ className, children, ...tableProps }: BetterDocTableProps) => (
  <div className="border-border bg-surface overflow-x-auto rounded-xl border">
    <table className={cn("w-full border-collapse text-left text-sm", className)} {...tableProps}>
      {children}
    </table>
  </div>
)

export const BetterDocTableHeaderCell = ({ className, ...cellProps }: BetterDocTableHeaderCellProps) => (
  <th
    scope="col"
    className={cn(
      "text-on-surface-subdued border-border border-b px-3 py-2 text-xs font-normal whitespace-nowrap",
      className,
    )}
    {...cellProps}
  />
)

export const BetterDocTableCell = ({ className, ...cellProps }: BetterDocTableCellProps) => (
  <td className={cn("text-on-surface border-border border-b px-3 py-2 align-top", className)} {...cellProps} />
)
